// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItemButton_menuItem___ozuZ"};